@let defaultRowHeight = defaultRowHeight$ | async;
@let pixelWidthPerDay = pixelWidthPerDay$ | async;
@if (
  {
    frameLength: frameLength$ | async,
    unassignedShiftsWithoutActivities:
      unassignedShiftsWithoutActivities$ | async,
    filteredUnassignedShiftsWithoutActivities:
      filteredUnassignedShiftsWithoutActivities$ | async,
    filteredUnassignedActivitiesViewRows:
      filteredUnassignedActivitiesViewRows$ | async,
    resourcesColumnWidthPx: resourcesColumnWidthPx$ | async,
    isLoadingUnassignedShifts: isLoadingUnassignedShifts$ | async,
    isRefreshingUnassignedShifts: isRefreshingUnassignedShifts$ | async,
    hideLoaderWhenLoadingUnassignedShiftsOrActivities:
      hideLoaderWhenLoadingUnassignedShiftsOrActivities$ | async,
    isLoadingUnassignedActivities: isLoadingUnassignedActivities$ | async,
    isRefreshingUnassignedActivities: isRefreshingUnassignedActivities$ | async,
    activity: activityDropZoneHelperService.activity$ | async,
    isLoadingUsers: isLoadingUsers$ | async,
    areActivitiesVisible: areActivitiesVisible$ | async,
    unassignedActivitiesViewRows: unassignedActivitiesViewRows$ | async,
    selectedTab: selectedTab$ | async,
    isUnassignedRegionExpanded: isUnassignedRegionExpanded$ | async,
  };
  as data
) {
  @if (
    {
      unassignedShiftsCount:
        data.filteredUnassignedShiftsWithoutActivities?.length || 0,
      unassignedActivitiesCount:
        data.filteredUnassignedActivitiesViewRows?.length || 0,
    };
    as formattedData
  ) {
    <wilson-unassigned-region-resize-handle
      (resizeStart)="unassignedRegionResizeService.onResizeStart()"
      (resizing)="unassignedRegionResizeService.onResize($event)"
      (resizeEnd)="unassignedRegionResizeService.onResizeEnd($event)"
    ></wilson-unassigned-region-resize-handle>
    <div
      id="left-container"
      [style.width.px]="data.resourcesColumnWidthPx"
      [style.min-width.px]="data.resourcesColumnWidthPx"
      [ngClass]="{ 'left-side-green-border': data.isUnassignedRegionExpanded }"
    >
      @if (
        data.isUnassignedRegionExpanded &&
        unassignedRegionResizeService.isLeftPanelContentVisible()
      ) {
        <div class="green-square">{{ 'general.unassigned' | translate }}</div>
        <wilson-unassigned-region-segment
          [resourcesColumnWidthPx]="data.resourcesColumnWidthPx"
          [selectedTab]="data.selectedTab"
          [isLoadingUnassignedShifts]="
            (!!data.isLoadingUnassignedShifts ||
              !!data.isRefreshingUnassignedShifts) &&
            !data.hideLoaderWhenLoadingUnassignedShiftsOrActivities
          "
          [isCellViewMode]="false"
          [isLoadingUnassignedActivities]="
            !!data.areActivitiesVisible &&
            (!!data.isLoadingUnassignedActivities ||
              !!data.isRefreshingUnassignedActivities) &&
            !data.hideLoaderWhenLoadingUnassignedShiftsOrActivities
          "
          (updateSelectedTab)="changeTabSelection($event)"
        ></wilson-unassigned-region-segment>
        @if (data.selectedTab === tabOptions.UnassignedShifts) {
          <wilson-unassigned-region-search-filter
            [resourcesColumnWidthPx]="data.resourcesColumnWidthPx"
            [unassignedShifts]="data.unassignedShiftsWithoutActivities"
          ></wilson-unassigned-region-search-filter>
        }
        @if (data.selectedTab === tabOptions.UnassignedActivities) {
          <wilson-unassigned-region-activity-search-filter
            [resourcesColumnWidthPx]="data.resourcesColumnWidthPx"
            [unassignedServices]="
              data.unassignedActivitiesViewRows | toServiceFilterData
            "
          ></wilson-unassigned-region-activity-search-filter>
        }
      }
      <wilson-assign-all-shift-without-activities-button
        [isLoadingUsers]="!!data.isLoadingUsers"
        [class.d-none]="unassignedRegionResizeService.isDragging()"
      ></wilson-assign-all-shift-without-activities-button>
    </div>
    <div
      #rightContainerWrapper
      class="right-container-wrapper"
      (dragover)="dragover($event)"
      (dragleave)="dragleave($event)"
      (drop)="drop($event, data.selectedTab)"
      (scroll)="updateScrollingPosition($event)"
      [ngClass]="{ 'right-side-green-border': data.isUnassignedRegionExpanded }"
    >
      @if (
        {
          isDeleteDropZone:
            data.selectedTab === tabOptions.UnassignedActivities &&
            !data.activity?.serviceId,
        };
        as data
      ) {
        <div
          class="drop-zone"
          [class.d-none]="!isHovered"
          [class.delete-drop-zone]="data.isDeleteDropZone"
        >
          @if (data.isDeleteDropZone) {
            <fa-icon [icon]="faTrashAlt" class="drop-zone-icon"></fa-icon>
          }
        </div>
      }
      <wilson-unassigned-region-toggle
        [isExpanded]="!!data.isUnassignedRegionExpanded"
        (modelChange)="manualToggleRegion($event)"
      ></wilson-unassigned-region-toggle>
      @if (!!data.isUnassignedRegionExpanded) {
        @if (
          data.selectedTab === tabOptions.UnassignedShifts &&
          data.isLoadingUnassignedShifts &&
          !data.hideLoaderWhenLoadingUnassignedShiftsOrActivities
        ) {
          <div class="loading-indicator">
            <nz-skeleton [nzActive]="true"></nz-skeleton>
          </div>
        } @else {
          @if (
            data.selectedTab === tabOptions.UnassignedShifts &&
            data.filteredUnassignedShiftsWithoutActivities?.length === 0
          ) {
            <ng-container *ngTemplateOutlet="emptyState"></ng-container>
          }
          @if (data.selectedTab === tabOptions.UnassignedShifts) {
            <wilson-unassigned-shift-without-activities-tab
              [style.width.px]="data.frameLength"
              [shifts]="data.filteredUnassignedShiftsWithoutActivities"
              [rowHeight]="defaultRowHeight"
              [visibleRows]="visibleOverlapRows$ | async"
              [pixelWidthPerDay]="pixelWidthPerDay"
            ></wilson-unassigned-shift-without-activities-tab>
          }
        }
        @if (
          data.selectedTab === tabOptions.UnassignedActivities &&
          data.isLoadingUnassignedActivities &&
          !data.hideLoaderWhenLoadingUnassignedShiftsOrActivities
        ) {
          <div class="loading-indicator">
            <nz-skeleton [nzActive]="true"></nz-skeleton>
          </div>
        } @else {
          <ng-container>
            @if (
              data.selectedTab === tabOptions.UnassignedActivities &&
              data.filteredUnassignedActivitiesViewRows?.length === 0
            ) {
              <ng-container *ngTemplateOutlet="emptyState"></ng-container>
            }
            @if (
              data.selectedTab === tabOptions.UnassignedActivities &&
              data.filteredUnassignedActivitiesViewRows
            ) {
              <wilson-unassigned-activities-row
                [style.width.px]="data.frameLength"
                [rows]="data.filteredUnassignedActivitiesViewRows"
              ></wilson-unassigned-activities-row>
            }
          </ng-container>
        }
      } @else {
        @let numberOfShiftPerDayRecord = numberOfShiftPerDayRecord$ | async;
        <wilson-unassigned-region-regular-view-collapsed-state-render
          [style.width.px]="data.frameLength"
          [isUnassignedRegionExpanded]="data.isUnassignedRegionExpanded"
          [pixelWidthPerDay]="pixelWidthPerDay || 0"
          [numberOfShiftPerDayRecord]="numberOfShiftPerDayRecord"
          (toggleRegion)="
            manualToggleRegion(!!!data.isUnassignedRegionExpanded)
          "
        ></wilson-unassigned-region-regular-view-collapsed-state-render>
      }
    </div>
  }
  <ng-template #emptyState>
    <div class="empty-state">
      <div class="d-flex flex-column align-items-center">
        <img
          src="assets/img/portal/Icon-Empty-state-table.svg"
          alt="Not-Found-List"
        />
        <span>
          {{
            (data.selectedTab === tabOptions.UnassignedActivities
              ? 'page.shift_timeline.no_service_found'
              : 'page.shift_timeline.no_shift_found'
            ) | translate
          }}
        </span>
      </div>
    </div>
  </ng-template>
}
